var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCellOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.544 12.4336H2C1.60218 12.4336 1.22064 12.2756 0.93934 11.9943C0.658035 11.7129 0.5 11.3314 0.5 10.9336L0.5 2.93359C0.5 2.53577 0.658035 2.15424 0.93934 1.87293C1.22064 1.59163 1.60218 1.43359 2 1.43359H18C18.3978 1.43359 18.7794 1.59163 19.0607 1.87293C19.342 2.15424 19.5 2.53577 19.5 2.93359V9.21159C18.9772 8.72687 18.299 8.44416 17.5867 8.4141C16.8744 8.38405 16.1747 8.60863 15.613 9.04759L11.875 11.9676C11.7217 12.0874 11.6066 12.2494 11.544 12.4336Z",
    fill: "#272C55",
    stroke: "#272C55",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.93359H19.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.43359V12.4336",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.43359V7.43359",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9.93359H10.5",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9869 10.7319L17.1355 12.2008C17.1119 12.2201 17.0939 12.236 17.0749 12.2508C16.1379 12.973 15.3403 13.6105 14.4013 14.3325C14.3557 14.3674 14.3051 14.3952 14.2511 14.4148C13.6575 14.622 13.0633 14.8275 12.4687 15.0312C12.4006 15.0613 12.3238 15.0659 12.2525 15.0442C12.1812 15.0225 12.1201 14.9759 12.0802 14.9129C12.0451 14.8606 12.0273 14.7985 12.0294 14.7354C12.0315 14.6724 12.0535 14.6116 12.0921 14.5618C12.3316 14.2033 12.5825 13.8502 12.8062 13.4807C13.0427 13.1028 13.3524 12.776 13.7171 12.5196C14.512 11.9291 15.1493 11.3998 15.9338 10.7949C15.9547 10.7756 15.9741 10.7547 15.9919 10.7325L15.9869 10.7319Z",
    fill: "#272D55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3788 10.422C16.6146 10.2494 16.8501 10.0708 17.0899 9.89874C17.2042 9.81813 17.3351 9.76398 17.473 9.74021C17.6109 9.71644 17.7523 9.72365 17.8871 9.76132C18.0218 9.79899 18.1465 9.86617 18.2521 9.95799C18.3576 10.0498 18.4414 10.164 18.4974 10.2922C18.5722 10.4647 18.5924 10.656 18.555 10.8403C18.5216 11.0318 18.4218 11.2054 18.2732 11.3306C18.0337 11.5249 17.7818 11.7055 17.5386 11.8893L16.3788 10.422Z",
    fill: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCellOperationIcon);
export default __webpack_public_path__ + "static/media/EditCellOperationIcon.29882c738014864201a9dc09a08d7d61.svg";
export { ForwardRef as ReactComponent };